import { DatadogTrack } from '@cobliteam/datadog-rum';
import { useUser } from '@cobliteam/hooks';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { Environment } from '@cobliteam/react-environments';
import { useEffect } from 'react';

const env = Environment.getInstance().getEnvironment();

export default function BlipChat() {
  const { getSession } = useUser();
  const session = getSession();

  const blipChatAppKey = env.blipChatAppKey;
  const featureFlags = useFeatureFlags();

  useEffect(() => {
    if (!(featureFlags.blipChat && session)) return;

    if (window.BlipChat && blipChatAppKey) {
      try {
        const blipChatBuilder = new window.BlipChat();
        const blipChatInstance = blipChatBuilder
          .withAppKey(blipChatAppKey)
          .withButton({ color: '#092bfe', icon: '', right: '0', top: '0' })
          .withCustomCommonUrl('https://cobli.chat.blip.ai/')
          .withAccount({
            fullName: session.user.name,
            email: session.user.email,
            extras: {
              fleetId: session.fleet.id,
              origem: 'Painel Cobli',
            },
          })
          .build();

        window.blipChatInstance = blipChatInstance;
        window.blipChatBuilder = blipChatBuilder;
      } catch (error) {
        DatadogTrack.error(error as Error, {
          component: 'NotificationsButton',
        });
      }
    }
  }, []);

  return null; // não renderiza nada visível
}
